import { useSelector } from 'react-redux';
import { SOFT_DELETED } from 'conversations-message-history/common-message-format/constants/messageDeleteStatus';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ThreadViewPlaceholder from 'conversations-thread-view/thread-view/components/ThreadViewPlaceholder';
import ConversationMovedToTrash from '../../thread-deletion/components/ConversationMovedToTrash';
import { useCurrentViewIsProcessing } from '../../custom-views/hooks/useCurrentViewIsProcessing';
import { useViewCanSeeDeletedMessages } from '../../thread-list/hooks/useViewCanSeeDeletedMessages';
import { ViewProgressState } from 'svh-workspace-ui-lib/custom-views/public';
import InboxThreadOverview from './InboxThreadOverview';
import { useInboxViewMembers } from 'find-and-filter-data/view-members-data/public';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getCurrentViewId } from '../../thread-list/selectors/getCurrentViewId';
import { getStatus } from 'find-and-filter-data/view-members-schema/protected';
import { useView } from 'find-and-filter-data/views-data/public';
import { getUnreadThreadCount } from 'find-and-filter-data/views-schema/public';
import NoUnreadThread from './zero-states/NoUnreadThread';
import NoFocusedThread from './zero-states/NoFocusedThread';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxMainViewContent = ({
  focusedThreadId
}) => {
  const showDeletedMessages = useViewCanSeeDeletedMessages();
  const inboxId = useSelector(getCurrentInboxId);
  const viewId = useSelector(getCurrentViewId);
  const {
    loading,
    viewMembers
  } = useInboxViewMembers({
    inboxId,
    skip: true,
    viewId: viewId || undefined
  });
  const threadListMember = viewMembers && focusedThreadId ? viewMembers.get(focusedThreadId) : {};
  const isThreadSoftDeletedBool = getStatus(threadListMember) === SOFT_DELETED;
  const showMovedToTrashState = isThreadSoftDeletedBool && !showDeletedMessages;
  const isCurrentViewEvaluating = useCurrentViewIsProcessing();
  const view = useView(inboxId, viewId);
  if (isCurrentViewEvaluating) {
    return /*#__PURE__*/_jsx(ViewProgressState, {});
  }
  if (showMovedToTrashState) {
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    return /*#__PURE__*/_jsx(ConversationMovedToTrash, {
      threadId: focusedThreadId
    });
  }
  if (focusedThreadId) {
    return /*#__PURE__*/_jsx(InboxThreadOverview, {
      focusedThreadId: focusedThreadId
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      className: "width-100 height-100",
      children: /*#__PURE__*/_jsx(ThreadViewPlaceholder, {})
    });
  }
  if (view !== undefined) {
    const unreadThreadCount = getUnreadThreadCount(view);
    if (unreadThreadCount !== null && unreadThreadCount > 0) {
      return /*#__PURE__*/_jsx(NoFocusedThread, {
        "data-test-id": "inbox-thread-loaded"
      });
    }
  }
  return /*#__PURE__*/_jsx(NoUnreadThread, {
    "data-test-id": "inbox-thread-loaded"
  });
};
InboxMainViewContent.displayName = 'InboxMainViewContent';
export default InboxMainViewContent;